<template>
    <div class="applaypage">
        <div class="applaypage-img">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/1.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/2.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/3.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/4.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/5.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/6.png" alt="">
        </div>
        <div class="applaypage-btn">
            <img class="applaypage-newbtn" src="../asset/images/buypage/7.png" alt="" @click="show = true">
        </div>
        <van-popup
        van-popup v-model="show" round position="bottom"
        @close="closing"
        class="user-info-sheet"
        >
            <div class="header">
                <span class="txt">请填写以下信息</span>
                <span class="close" @click="closing">关闭</span>
            </div>
            <div class="body">
                <p class="label">
                    请输入姓名
                </p>
                <div class="input-wrap input">
                    <van-cell-group>
                        <van-field v-model="filter.name"  placeholder="请输入姓名" maxlength="10"/>
                    </van-cell-group>
                    <p class="errtext" v-if="noname">姓名不能为空</p>
                </div>
                <p class="label">
                    请输入手机号
                </p>
                <div class="input-wrap input">
                    <van-cell-group>
                        <van-field v-model="filter.phone"  placeholder="请输入手机号"/>
                    </van-cell-group>
                    <p class="errtext" v-if="nophone">{{errorphone}}</p>
                </div>
            </div>
            <div class="footer">
                <img class="btn" @click="changeApply" src="../asset/images/buypage/tijiao-btn.jpg" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'applayPage',
    data() {
        return {
            show: false,
            filter: {
                name: '',
                phone: '',
            },
            noname: false,
            nophone: false,
            errorphone: '',
        };
    },
    components: {},
    methods: {
        closing() {
            this.show = false;
        },
        changeApply(){
            this.show = true;
            this.noname = this.filter.name ? false : true;
            let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            if(this.filter.phone.length === 0){
                this.nophone = true;
                this.errorphone = "请输入手机号"
            } else if(!reg.test(this.filter.phone)){
                this.nophone = true;
                this.errorphone = '请输入正确的手机号码';
            } else {
                this.nophone = false;
            }
            if(!this.noname && !this.nophone){
                let data = this.filter;
                this.$api.order.changeTaskApply({data}).then( (res) => {
                    // console.log(res);
                    if(res.success){
                        this.$toast('提交成功，工作人员会尽快与您联系');
                        this.show = false;
                        this.filter = {
                            name: '',
                            phone: '',
                        }
                    }
                })
            }
        },
    },
    mounted() {}
};
</script>

<style scoped lang="less">
@import url('../asset/css/applaypage.less');
</style>
<style lang="less">
.applaypage{
    .user-info-sheet {
    .flex {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }
    .header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E6E6EB;
        font-weight: 500;
        padding: 0 32px;
        line-height: 120px;
        .txt {
            color: #272F55;
            font-size: 40px;
        }
        .close {
            color: #E85A3A;
            font-size: 32px;
        }
    }
    .body {
        padding: 48px 32px 0;
        text-align: left;
        .label {
            color: #575765;
            font-size: 32px;
            line-height: 44px;
            margin-bottom: 28px;
        }
        .errtext{
            color:#E85A3A;
            font-size: 14px;
            padding: 5px;
        }
        .input-wrap {
            height: 88px;
        }
        .input {
            margin-bottom: 48px;
            .van-cell {
                background: #F3F3F3;
                border-radius: 0.32rem;
                font-size: 0.853rem;
                padding-left: 0.64rem;
            }
            .van-hairline--top-bottom::after{
                border-width: 0px;
            }
        }
        .area {
            margin-bottom: 266px;
            display: flex;
            justify-content: space-between;
            line-height: 88px;
            .van-icon {
                line-height: 2.346rem;
                color: #A7ADBB;
            }
        }
        .area-block {
            width: 260px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .city {
            width: 280px;
            background: #F3F3F3;
            padding: 0 16px 0 24px;
            border-radius: 12px;
            color: #272F55;
            font-size: 32px;
        }
        .bar {
            width: 24px;
            height: 8px;
            background: #F3F3F3;
            margin-top: 40px;
            border-radius: 4px;
        }
        .company {
            width: 350px;
            background: #F3F3F3;
            padding: 0 16px 0 24px;
            border-radius: 12px;
            color: #272F55;
            font-size: 32px;
        }
    }
    .footer {
        width: 100%;
        .btn {
            display: block;
            width: 95%;
            margin: 20px auto;
        }
    }
}}
    // .van-overlay{
    //     top: -68px;
    // }
    // .van-popup--bottom{
    //     bottom: 68px;
    // }
//     .van-action-sheet__content{
//         padding-bottom: 100px;
//         // margin-bottom: 1px;
//         .content{
//             width: 91%;
//             margin: 0px auto;
//             h3{
//                 font-size: 16px;
//                 color: #666;
//                 padding: 10px 0px;
//                 font-family: PingFangSC-Medium, PingFang SC;
//                 font-weight: 400;
//             }
//             input{
//                 border: none;
//                 width: 95%;
//                 background: rgba(0,0,0,0.1);
//                 font-family: PingFangSC-Medium, PingFang SC;
//                 height: 24px;
//                 padding: 5px 10px;
//                 font-size: 16px;
//                 border-radius: 8px;
//                 margin-bottom: 20px;
//             }
//             .content-btn{
//                 position: fixed;
//                 bottom: 0px;
//                 left: 0px;
//                 width: 100%;
//                 background: #FFFFFF;
//                 box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
//                 .content-newbtn{
//                     width: 91%;
//                     background: #F1430D;
//                     color: #fff;
//                     font-size: 16px;
//                     margin: .426667rem auto;
//                     text-align: center;
//                     letter-spacing: .053333rem;
//                     height: 44px;
//                     border-radius: 38px;
//                     line-height: 44px;
//                 }
                    
//             }
//         }
//     }
// }
</style>
